var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row-content mb10" }, [
      _c("div", { staticClass: "row-item column-layout flex" }, [
        _c("div", { staticClass: "fl col-10" }, [
          _c("span", [_vm._v("员工所在公司：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.staffInfo.comName || ""))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "fl col-10" }, [
          _c("span", [_vm._v("员工名称：")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.staffInfo.name || ""))]),
          _vm._v(" "),
          _vm.showChangeStaff
            ? _c(
                "a",
                {
                  staticClass: "swb-btn  swb-btn-link",
                  on: {
                    click: function($event) {
                      _vm.staffForselect()
                    }
                  }
                },
                [_vm._v("选择")]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "fl col-4" }, [
          _vm.thisStaffId != null
            ? _c(
                "a",
                {
                  staticClass: "swb-btn  swb-btn-link fr",
                  class: _vm.btnState ? "" : "swb-btn-disabled",
                  attrs: { title: _vm.btnState ? "" : "暂未订阅" }
                },
                [
                  _vm.btnState
                    ? _c(
                        "span",
                        {
                          on: {
                            click: function($event) {
                              _vm.showEventMsgSubscrList()
                            }
                          }
                        },
                        [_vm._v("查看已订阅")]
                      )
                    : _c("span", [_vm._v("查看已订阅")])
                ]
              )
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "column-layout flex" }, [
      _c(
        "div",
        { staticClass: "fl col-6 pr20", staticStyle: { "overflow-y": "auto" } },
        [
          _c("swb-org-tree", {
            ref: "swb_org_tree",
            staticClass: "msg-subscr",
            attrs: { searchSize: "mini", accordion: true, isShowIcon: false },
            on: {
              "notity-change": function($event) {
                _vm.notityChange($event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "fl col-18" }, [
        _c(
          "div",
          {
            staticStyle: {
              "background-color": "#E6F3FC",
              padding: "5px 10px",
              margin: "10px 0"
            }
          },
          [
            _c("span", { staticClass: "font-gray2" }, [
              _vm._v("当前订阅公司：")
            ]),
            _vm._v(" "),
            _vm.comName == null
              ? _c("span", { staticClass: "font-red" }, [_vm._v("未选择")])
              : _c("span", { staticClass: "font-block font-bold" }, [
                  _vm._v(_vm._s(_vm.comName))
                ]),
            _vm._v(" "),
            _vm.thisComSelect
              ? _c("el-tag", { attrs: { type: "success" } }, [_vm._v("已订阅")])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row-content " }, [
          _c("div", { staticClass: "row-item column-layout flex" }, [
            _c("div", { staticClass: "fl col-6" }, [
              _c("span", [_vm._v("消息主题：")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.bizEventMsg.topicName))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "fl col-6 ellipsis-1 pr5" }, [
              _c("span", [_vm._v("事件名称：")]),
              _vm._v(" "),
              _c("span", { attrs: { title: _vm.bizEventMsg.name } }, [
                _vm._v(_vm._s(_vm.bizEventMsg.name))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "fl col-12" },
              [
                _c("span", [_vm._v("支持方式：")]),
                _vm._v(" "),
                _vm.bizEventMsg.siteMsgFlag
                  ? _c(
                      "el-checkbox",
                      {
                        staticClass: "ml20",
                        on: { change: _vm.changeSaveFlag },
                        model: {
                          value: _vm.siteMsgFlag,
                          callback: function($$v) {
                            _vm.siteMsgFlag = $$v
                          },
                          expression: "siteMsgFlag"
                        }
                      },
                      [_vm._v("站内信")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.bizEventMsg.emailFlag
                  ? _c(
                      "el-checkbox",
                      {
                        staticClass: "ml20",
                        on: { change: _vm.changeSaveFlag },
                        model: {
                          value: _vm.emailFlag,
                          callback: function($$v) {
                            _vm.emailFlag = $$v
                          },
                          expression: "emailFlag"
                        }
                      },
                      [_vm._v("邮箱")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.bizEventMsg.wxFlag
                  ? _c(
                      "el-checkbox",
                      {
                        staticClass: "ml20",
                        on: { change: _vm.changeSaveFlag },
                        model: {
                          value: _vm.wxFlag,
                          callback: function($$v) {
                            _vm.wxFlag = $$v
                          },
                          expression: "wxFlag"
                        }
                      },
                      [_vm._v("微信")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.bizEventMsg.siteMsgFlag &&
                !_vm.bizEventMsg.emailFlag &&
                !_vm.bizEventMsg.wxFlag
                  ? _c("span", { staticClass: "mr5" }, [_vm._v("无")])
                  : _vm._e()
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _vm.wxFlag
          ? _c("div", { staticClass: "row-content mt5" }, [
              _c("div", { staticClass: "row-item column-layout flex" }, [
                _c(
                  "div",
                  { staticClass: "fl col-24" },
                  [
                    _c("span", [_vm._v("订阅小程序：")]),
                    _vm._v(" "),
                    _c(
                      "el-checkbox",
                      {
                        on: { change: _vm.changeSaveFlag },
                        model: {
                          value: _vm.selectMiniApp,
                          callback: function($$v) {
                            _vm.selectMiniApp = $$v
                          },
                          expression: "selectMiniApp"
                        }
                      },
                      [_vm._v("选择小程序")]
                    ),
                    _vm._v(" "),
                    _vm.selectMiniApp
                      ? _c("div", { staticClass: "inline-block" }, [
                          _vm.bizEventMsgAppList != null &&
                          _vm.bizEventMsgAppList.length > 0
                            ? _c(
                                "div",
                                { staticClass: "inline-block ml10" },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      on: { change: _vm.changeSaveFlag },
                                      model: {
                                        value: _vm.appAlias,
                                        callback: function($$v) {
                                          _vm.appAlias = $$v
                                        },
                                        expression: "appAlias"
                                      }
                                    },
                                    _vm._l(_vm.bizEventMsgAppList, function(
                                      eventMsgApp
                                    ) {
                                      return _c(
                                        "el-radio",
                                        {
                                          attrs: { label: eventMsgApp.appAlias }
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.miniAppAliases[
                                                  eventMsgApp.appAlias
                                                ]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    })
                                  )
                                ],
                                1
                              )
                            : _c("span", { staticClass: "font-red ml10" }, [
                                _vm._v("未设置小程序")
                              ])
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.bizEventMsg.goodsRelated
          ? _c("div", { staticStyle: { "min-height": "100px" } }, [
              _c(
                "div",
                { staticClass: "content-caption dashed" },
                [
                  _c("span", [_vm._v("商品分类")]),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "ml20",
                      on: {
                        change: function($event) {
                          _vm.goodsCatSet()
                        }
                      },
                      model: {
                        value: _vm.goodsCatForAll,
                        callback: function($$v) {
                          _vm.goodsCatForAll = $$v
                        },
                        expression: "goodsCatForAll"
                      }
                    },
                    [_vm._v("全部分类")]
                  ),
                  _vm._v(" "),
                  !_vm.goodsCatForAll
                    ? _c(
                        "a",
                        {
                          staticClass: "fr swb-btn swb-btn-link mt10",
                          on: {
                            click: function($event) {
                              _vm.goodsCatForselect()
                            }
                          }
                        },
                        [_vm._v("选择")]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "switch-list clearfix" },
                _vm._l(_vm.goodsCatList, function(goodsCat) {
                  return _c(
                    "li",
                    {
                      staticClass: "switch-item ellipsis-1",
                      staticStyle: { width: "auto", "margin-right": "30px" }
                    },
                    [_c("a", [_vm._v(_vm._s(goodsCat.catName))])]
                  )
                })
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.bizEventMsg.servcRelated
          ? _c("div", { staticStyle: { "min-height": "100px" } }, [
              _c(
                "div",
                { staticClass: "content-caption dashed" },
                [
                  _c("span", [_vm._v("服务分类")]),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "ml20",
                      on: {
                        change: function($event) {
                          _vm.servcCatSet()
                        }
                      },
                      model: {
                        value: _vm.servcCatForAll,
                        callback: function($$v) {
                          _vm.servcCatForAll = $$v
                        },
                        expression: "servcCatForAll"
                      }
                    },
                    [_vm._v("全部分类")]
                  ),
                  _vm._v(" "),
                  !_vm.servcCatForAll
                    ? _c(
                        "a",
                        {
                          staticClass: "fr swb-btn swb-btn-link mt10",
                          on: {
                            click: function($event) {
                              _vm.servcCatForselect()
                            }
                          }
                        },
                        [_vm._v("选择")]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "switch-list clearfix" },
                _vm._l(_vm.servcCatList, function(servcCat) {
                  return _c(
                    "li",
                    {
                      staticClass: "switch-item ellipsis-1",
                      staticStyle: { width: "auto", "margin-right": "30px" }
                    },
                    [_c("a", [_vm._v(_vm._s(servcCat.catName))])]
                  )
                })
              )
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-da87a690", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da87a690","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/bizMsg/MsgSubscrDlg.vue
// module id = 3404
// module chunks = 0